export * from './course-passes-table.component';
export * from './course-passes-table.module';
